import { all } from 'redux-saga/effects'

export default class RedirectionsSagas {
  static *loop() {
    yield all([])
  }
}
